export const RANGER_STORE_DEFAULT_STATE = {
  loading: false,
  isError: false,
  controls: [],
};
